import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "d-flex gap-2 justify-content-end"
}

import { computed } from "vue";
  import SpecificDateOpeningHours from "./SpecificDateOpeningHours.vue";
  import DeleteEntries from "./DeleteEntries.vue";
  import dayjs from "dayjs";
  import "dayjs/locale/de";

  // Initialize dayjs locale
  
export default {
  __name: 'OpeningHoursTableRow',
  props: {
    item: { type: Object, required: true },
  },
  setup(__props) {

  dayjs.locale("de");

  // Constants
  const WEEKDAYS = {
    1: "Montag",
    2: "Dienstag",
    3: "Mittwoch",
    4: "Donnerstag",
    5: "Freitag",
    6: "Samstag",
    7: "Sonntag",
  };

  // Props
  const props = __props;

  // Helper functions
  const formatDate = (dateStr) => (dateStr ? dayjs(dateStr).format("DD.MM.YYYY") : "-");
  const formatTime = (timeStr) => (timeStr ? dayjs(timeStr).format("HH:mm") : "-");
  const formatFullDate = (dateStr) => (dateStr ? dayjs(dateStr).format("dddd, DD.MM.YYYY") : "-");
  const getWeekdayName = (weekday) => WEEKDAYS[weekday] || "-";

  // Computed properties
  const isSpecialDate = computed(() => !!props.item.specificDate);

  const modalId = computed(() => (isSpecialDate.value ? `spec-modal${props.item.id}` : null));

  const dayOrDateFormatted = computed(() => {
    const { weekday, specificDate } = props.item;

    if (weekday !== null) return getWeekdayName(weekday);
    if (specificDate) return formatFullDate(specificDate.date);
    return "-";
  });

  const timeFormatted = computed(() => {
    const { startTime, endTime } = props.item;
    if (!startTime || !endTime) return "Geschlossen";

    return `${formatTime(startTime.date)} - ${formatTime(endTime.date)}`;
  });

  const validityPeriod = computed(() => {
    const { validFrom, validUntil } = props.item;
    if (!validFrom?.date) return null;

    return validUntil?.date
      ? `${formatDate(validFrom.date)} - ${formatDate(validUntil.date)}`
      : `ab ${formatDate(validFrom.date)}`;
  });

  const comment = computed(() => {
    const { comment } = props.item;
    return comment;
  })

return (_ctx, _cache) => {
  const _component_b_button = _resolveComponent("b-button")
  const _directive_b_modal = _resolveDirective("b-modal")

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", null, _toDisplayString(dayOrDateFormatted.value), 1 /* TEXT */),
    _createElementVNode("td", null, _toDisplayString(timeFormatted.value), 1 /* TEXT */),
    (validityPeriod.value)
      ? (_openBlock(), _createElementBlock("td", _hoisted_1, _toDisplayString(validityPeriod.value), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (!validityPeriod.value)
      ? (_openBlock(), _createElementBlock("td", _hoisted_2, _toDisplayString(comment.value), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (isSpecialDate.value)
      ? (_openBlock(), _createElementBlock("td", _hoisted_3, [
          _withDirectives((_openBlock(), _createBlock(_component_b_button, {
            size: "sm",
            variant: "outline-primary"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          })), [
            [_directive_b_modal, modalId.value]
          ]),
          _createVNode(SpecificDateOpeningHours, {
            "modal-id": modalId.value,
            "initial-values": __props.item
          }, null, 8 /* PROPS */, ["modal-id", "initial-values"]),
          _createVNode(DeleteEntries, {
            entries: [__props.item]
          }, null, 8 /* PROPS */, ["entries"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

}